/**
 * Dati utente post-login: Studio + file asta attiva
 */
import { log } from "../utils/logger.js";
import { filtersManager } from "../features/filters/index.js";

export const userDataMethods = {
  async reloadUserData() {
    log.info("Dati utente: Ricaricamento...");
    await this.loadStudioTargets();
    await this.loadStudioBudget();
    if (typeof this.loadStudioUserLabels === 'function') {
      await this.loadStudioUserLabels();
    }
    if (typeof this.loadStudioDrafts === 'function') {
      this.loadStudioDrafts();
    }
    if (typeof this.ensureActiveAuction === 'function') {
      await this.ensureActiveAuction();
    }
    if (this.state.allPlayers.length > 0) {
      filtersManager.setPlayers(this.state.allPlayers);
    }
    if (typeof this.syncAuctionModeListFilters === "function") {
      this.syncAuctionModeListFilters();
    } else {
      filtersManager.applyFilters();
    }
    if (typeof this.updateRosaTabCount === 'function') {
      this.updateRosaTabCount();
    }
    log.info("Dati utente: Ricaricati");
  },
};
